// extracted by mini-css-extract-plugin
export default {"homeColumn":"index_homeColumn_Q891k","brandPicBox":"index_brandPicBox_0ejam","brandPic":"index_brandPic_tVD9Q"};